import "./OurMethod.module.css";
import Header from "@/reusable_sections/Header";
import DeJijop1Methode from "./sections/DeJijop1Methode";
import TheScratchEdge from "./sections/TheScratchEdge";
import FrequentlyAskedQuestions from "./sections/FrequentlyAskedQuestions";
import Footer from "@/reusable_sections/Footer";
export default function OurMethodPage() {
  return <div>
      <Header />
      <DeJijop1Methode />
      <TheScratchEdge />
      <FrequentlyAskedQuestions />
      <Footer />
    </div>;
}